module.exports = __webpack_public_path__ + "static/media/species1.64e8d52b.png";